import { StatusPill, type Tone } from "@/components/ui";
import type { MessagingCampaignStatus } from "@/types/api";

/**
 * The two states of the messaging section that more than one page draws: what last happened to an
 * email (the journal, one email's detail) and where a campaign stands (the list, the editor).
 * Each maps ITS states to a tone; an unknown one shows as itself, on the neutral tone.
 */

export function EventBadge({ event }: { event: string | null }) {
  const value = event ?? "unknown";
  const tone: Tone =
    value === "delivered"
      ? "success"
      : value === "bounced" || value === "failed" || value === "complained"
        ? "danger"
        : value === "delivery_delayed"
          ? "warning"
          : value === "opened" || value === "clicked"
            ? "info"
            : "neutral";
  return <StatusPill tone={tone}>{value}</StatusPill>;
}

export function CampaignStatusBadge({ status }: { status: MessagingCampaignStatus }) {
  const tone: Tone =
    status === "sent"
      ? "success"
      : status === "failed"
        ? "danger"
        : status === "sending" || status === "resolving"
          ? "info"
          : status === "ready"
            ? "warning"
            : "neutral";
  return <StatusPill tone={tone}>{status}</StatusPill>;
}
